module.exports = new __parcel__URL__("pacman-munch.908dda4d.mp3").toString();